import React from 'react';

const ActivitySummary = () => {
  const activities = [
    { name: 'Activity 1', minutes: 120 },
    { name: 'Activity 2', minutes: 90 },
    { name: 'Activity 3', minutes: 150 },
  ];

  return (
    <div className="card">
      <h2>Weekly Minutes by Community (Last 7 Days)</h2>
      <div className="metrics">
        {activities.map((activity, index) => (
          <div key={index} className="activity">
            <h3>{activity.name}</h3>
            <p>{activity.minutes} minutes</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActivitySummary;